import React, {useCallback} from 'react';

export const exportTxt = (filename, text) => {
    const element = document.createElement('a');
    const blob = new Blob([text], {type: 'text/plain;charset=utf-8'});
    element.href = URL.createObjectURL(blob);
    element.download = filename + '.txt';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};
